import client from './client';

/* eslint-disable import/prefer-default-export, @typescript-eslint/explicit-module-boundary-types */
export const sign = ({ contractId }: { contractId: string }) => client.request({
  method: 'PUT',
  url: `/contracts/${contractId}/sign`,
});
/* eslint-enable import/prefer-default-export, @typescript-eslint/explicit-module-boundary-types */
